/*
 * Bypasses angular security checker for the given styles string.
 *
 * @unstable
 */

import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeStyle',
  standalone: false,
})
export class SafeStyle implements PipeTransform {
  readonly sanitizer = inject(DomSanitizer);

  public transform(style: string | null): any {
    return this.sanitizer.bypassSecurityTrustStyle(style);
  }
}
